import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styled from "styled-components";
import { greyText, lightGreys } from "../../../styles";
import { CompassParagraph } from "../styledComponents";

export const MarkdownContainer = styled.div<{
  minHeight?: string;
  maxHeight?: string;
}>`
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  min-height: ${({ minHeight }): string => minHeight || "120px"};
  max-height: ${({ maxHeight }): string => maxHeight || "400px"};
  overflow-y: auto;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${lightGreys.borderLightGrey};
  font-family: "Apercu";
  font-size: 13px;
  background-color: white;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0 4px;
  }

  p {
    margin: 4px 0;
  }

  ul,
  ol {
    padding-left: 20px;
    margin: 4px 0;
  }

  code {
    background-color: ${lightGreys.KPIBackground};
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 12px;
  }

  pre {
    background-color: ${lightGreys.KPIBackground};
    padding: 8px 12px;
    border-radius: 6px;
    overflow-x: auto;

    code {
      background-color: transparent;
      padding: 0;
    }
  }

  blockquote {
    border-left: 3px solid ${lightGreys.borderLightGrey};
    margin: 4px 0;
    padding-left: 12px;
    color: ${greyText};
  }

  table {
    border-collapse: collapse;
    margin: 8px 0;

    th,
    td {
      border: 1px solid ${lightGreys.borderLightGrey};
      padding: 4px 8px;
    }
  }

  a {
    color: #4b88ff;
  }

  hr {
    border: none;
    border-top: 1px solid ${lightGreys.borderLightGrey};
    margin: 8px 0;
  }
`;

export interface NoteViewerProps {
  content: string;
  emptyText?: string;
  minHeight?: string;
  maxHeight?: string;
}

export const NoteViewer: React.FC<NoteViewerProps> = ({
  content,
  emptyText = "No content",
  minHeight,
  maxHeight,
}) => {
  return (
    <MarkdownContainer minHeight={minHeight} maxHeight={maxHeight}>
      {content ? (
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      ) : (
        <CompassParagraph color={greyText}>{emptyText}</CompassParagraph>
      )}
    </MarkdownContainer>
  );
};
